exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_container_Pd31S {\n  width: 100%;\n  max-width: 100vw;\n  padding-bottom: 3.0625rem;\n}\n\n.index_container_Pd31S ul {\n  list-style: none;\n}\n\n.index_container_Pd31S * {\n  box-sizing: border-box;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "index_container_Pd31S"
};